export * from './configuracao-boleto-browse.component';
export * from './configuracao-boleto-edit.component';